function Tile() {
    "use strict";

    this.OrganizationId = -1;
    this.UserId = -1;
    this.Name = "";
    this.Value = "";
    this.NavigationHash = "";
}
if (typeof exports !== 'undefined') {
    module.exports = Tile;
}